import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StandardStatisticsData } from '../../../models/statistics';
import { ListItemRendererComponent } from 'gung-list';

type SortKey = 'productName' | 'salesAmount' | 'quantity' | 'numberOfOrders';

interface MappedData {
  productId: string;
  productName: string;
  salesAmount: number;
  quantity: number;
  numberOfOrders: number;
}

@Component({
    selector: 'lib-order-analytics-product-table',
    templateUrl: './order-analytics-product-table.component.html',
    styleUrls: ['./order-analytics-product-table.component.css'],
    standalone: false
})
export class OrderAnalyticsProductTableComponent extends ListItemRendererComponent<StandardStatisticsData[]> implements OnInit, OnChanges {
  public mappedData: MappedData[] = [];
  public sortedData: MappedData[] = [];
  public sortKey: SortKey = 'salesAmount';
  public sortAsc = false;

  ngOnInit(): void {
    this.mountTableData(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.mountTableData(this.data);
    }
  }

  toggleSort(key: SortKey): void {
    if (this.sortKey === key) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortKey = key;
      this.sortAsc = false;
    }
    this.applySort();
  }

  protected applySort(): void {
    const dir = this.sortAsc ? 1 : -1;
    const key = this.sortKey;
    this.sortedData = [...this.mappedData].sort((a, b) => {
      if (key === 'productName') {
        return (a.productName || '').localeCompare(b.productName || '') * dir;
      }
      return (a[key] - b[key]) * dir;
    });
  }

  protected mountTableData(data: StandardStatisticsData[]): void {
    this.mappedData = [];
    const productOrderIdMap: { [s: string]: number } = {};

    for (const row of data) {
      productOrderIdMap[row.productId] = (productOrderIdMap[row?.productId] || 0) + 1;

      const tableDataFoundIndex = this.mappedData.findIndex(td => td.productId === row.productId);

      if (tableDataFoundIndex > -1) {
        this.mappedData[tableDataFoundIndex].quantity += row.orderRowTotalQuantity;
        this.mappedData[tableDataFoundIndex].salesAmount += row.orderRowTotalValueCurrency;
      } else {
        this.mappedData.push({
          productId: row.productId,
          productName: row.productName,
          salesAmount: row.orderRowTotalValueCurrency || 0,
          quantity: row.orderRowTotalQuantity || 0,
          numberOfOrders: 0
        });
      }
    }

    for (const dataItem of this.mappedData) {
      dataItem.numberOfOrders = productOrderIdMap[dataItem.productId] || 0;
    }

    this.applySort();
    this.renderFinished?.emit();
  }
}
